import angular from 'angular';

import uploadClassicComponent from '~/components/upload/upload-classic/upload-classic.component';
import uploadClassicBlock from '~/components/upload/upload-classic-block/upload-classic-block.component';
import uploadClassicLinks from '~/components/upload/upload-classic-links/upload-classic-links.component';
import uploadErrorsRun from '~/components/upload/upload-classic/upload-errors.run';
import kFileUploadDirective from './k-file-upload.directive';

export default angular
	.module('app.upload', [])
	.run(uploadErrorsRun)
	.component('uploadClassic', uploadClassicComponent)
	.component('uploadClassicBlock', uploadClassicBlock)
	.component('uploadClassicLinks', uploadClassicLinks)
	.directive('kFileUpload', kFileUploadDirective)
	.name;
